import { useQuery } from '@tanstack/react-query';
import { apiClient } from 'api';
import { useToast } from 'hooks/useToast';

interface Source {
  name: string;
  count: number;
}

interface AvgTimeSpent {
  value: string;
  growth: number;
}

interface CompletionRate {
  value: string;
  percentage: number;
  growth: number;
}

interface RoleCounts {
  used: number;
  allowed: number;
  remaining: number;
  display: string;
}

export interface ManageJobsDashboardData {
  total_talents: number;
  sources: Source[];
  avg_time_spent: AvgTimeSpent;
  completion_rate: CompletionRate;
  role_counts: RoleCounts;
}

interface ManageJobsDashboardResponse {
  message: string;
  data: ManageJobsDashboardData;
}

/**
 * Hook for fetching manage jobs dashboard overview statistics
 */
export const useManageJobsDashboard = () => {
  const { openToast } = useToast();

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['manageJobsDashboard'],
    queryFn: async () => {
      const response = await apiClient.get<ManageJobsDashboardResponse>('/candidate/dashboard/overview/');
      return response.data.data;
    },
    retry: 1,
  });

  if (error) {
    const errorMessage = (error as any).response?.data?.message || (error as any).message || 'Failed to fetch dashboard overview';
    openToast({
      show: true,
      heading: "Error",
      text: errorMessage,
      type: "error",
      timeOut: 5000,
    });
  }

  return {
    dashboardData: data,
    isLoading,
    error,
    refetch,
  };
};
